import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import mineCraftApi from 'src/api/mineCraftApi';
import minecraftUrls from "src/configs/mine_craft/minecraftUrls";
import { ChallengeInterface } from 'src/store/mine_craft/challengesSlice';
import {fetchAddonsCollection} from "./addonsActions";

const processStrategy = (value: any) => {
  return {
    ...value,
    url: minecraftUrls.challengePath(value.id),
    thumbnail_url: minecraftUrls.remoteUrl(value.thumbnail_url),
    ico_url: minecraftUrls.remoteUrl(value.ico_url)
  };
}

export const challengesEntity = new schema.Entity(
  'challenges',
  {},
  {
    processStrategy
  }
);

export const challengeEntity = new schema.Entity(
  'challenge',
  {},
  {
    processStrategy
  }
);

const fetchChallengesCollection = async (url: string, params: object = {}) => {
  const response    = await mineCraftApi.get(url, { params })
  const normalized  = normalize<
    any,
    {
      challenges: { [key: string]: ChallengeInterface };
    }
  >(response.data.challenges, [challengesEntity]);

  return {
    challenges: normalized.entities?.challenges || {},
    ids: normalized.result,
    count: response.data.meta?.total_count
  };
}

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    {
      challenge: ChallengeInterface;
    }
  >(response.data.challenge, challengeEntity);
  return normalized.entities;
}

export const fetchChallenges = createAsyncThunk(
  'challenges/fetchChallenges',
  async (params: object = {}) => {
    const url = params['state'] ? `/onesky/challenges/${params['state']}` : '/onesky/challenges';

    return fetchChallengesCollection(url, params);
  }
);

export const fetchChallenge = createAsyncThunk(
  'challenges/fetchChallenge',
  async (id: number | string) => {
    const response = await mineCraftApi.get(`/onesky/challenges/${id}`);
    return normalizeInstance(response);
  }
);

export const createChallenge = createAsyncThunk(
  'challenges/createChallenge',
  async (data: object, { rejectWithValue }) => {
    try {
      const response = await mineCraftApi.post(`/onesky/challenges`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const updateChallenge = createAsyncThunk(
  'challenges/updateChallenge',
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await mineCraftApi.patch(`/onesky/challenges/${id}`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);

export const destroyChallenge = createAsyncThunk(
  'challenges/destroyChallenge',
  async (id: number) => {
    const response = await mineCraftApi.delete(`/onesky/challenges/${id}`);
    return response.data;
  }
);

export const fetchChallengesAddons = createAsyncThunk(
  'addons/fetchAddons',
  async ({ id, params } : { id: number, params: object }) => fetchAddonsCollection(`/onesky/challenges/${id}/addons`, params)
);
